import React, { Component } from "react";
import { Dialog } from "../../components/dialogs/Dialog";
import { TextField } from "../../components/TextField";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";

interface CompanyNameDialogProps extends WithLocaleProps {
  organization?: any;
  user?: any;
  theme?: any;
  onClose?: () => void;
  onSave?: (name: string) => void;
  error?: string;
}

class CompanyNameDialogBase extends Component<CompanyNameDialogProps, any> {
  constructor(props: CompanyNameDialogProps) {
    super(props);

    this.state = {
      companyName: props.organization ? props.organization.name : "",
      valid: false
    };
  }

  onNameChange(e: any) {
    const { organization } = this.props;
    this.setState({
      companyName: e.target.value,
      valid: e.target.value !== organization.name && e.target.value.length > 2
    });
  }

  onSave() {
    const { companyName } = this.state;
    if (this.props.onSave) this.props.onSave(companyName);
  }

  render() {
    const { theme, onClose, translate } = this.props;
    const { companyName, valid } = this.state;

    const changeAllowed = false;

    return (
      <Dialog
        open={true}
        theme={theme}
        title={translate("company.companyName")}
        onClose={onClose}
        maxWidth='sm'
        actions={[
          {
            label: translate("common.save"),
            visible: changeAllowed,
            variant: "filled",
            disabled: !valid,
            onClick: this.onSave.bind(this)
          },
          {
            label: changeAllowed ? translate("common.cancel") : translate("common.close"),
            variant: changeAllowed ? "outline" : "filled",
            autoFocus: !changeAllowed,
            onClick: onClose
          }
        ]}
      >
        {!changeAllowed && <div>{translate("company.contactToChange")}</div>}
        {changeAllowed && (
          <TextField
            label={translate("company.company")}
            placeholder={translate("company.companyName")}
            autoComplete={false}
            sx={{ width: "100%" }}
            value={companyName}
            onChange={this.onNameChange.bind(this)}
          />
        )}
      </Dialog>
    );
  }
}

export const CompanyNameDialog = withLocale(CompanyNameDialogBase);
